<form [formGroup]="form">
  <div class="flex flex-col gap-6 px-4">
    <h2 class="required text-[18px] font-semibold" i18n="@@adminRejectionReasonCreation">Rejection Reason Creation</h2>
    <div class="create-rejection-card mt-2 rounded-[8px] border bg-white px-6 py-6 shadow-sm">
      <div class="grid grid-cols-2 items-start gap-6">
        <div class="flex flex-col gap-2">
          <label class="text-[14px] font-semibold text-gray-700">
            {{ reasonArabicLabel }}
            <span class="required">*</span>
          </label>

          <app-filter-input
            label=""
            [placeholder]="reasonARPlaceholder"
            [value]="form.controls.reasonAR.value"
            (valueChange)="onArabicValueChange($event)"
            [isInvalid]="showValidationErrors() && form.controls.reasonAR.invalid"></app-filter-input>

          @if (showValidationErrors() && form.controls.reasonAR.errors) {
            <p class="text-sm text-red-600">
              @if (form.controls.reasonAR.hasError("required")) {
                {{ rejectionReasonArabicRequired }}
              } @else if (form.controls.reasonAR.hasError("minlength")) {
                {{ rejectionReasonMinLength }}
              } @else if (form.controls.reasonAR.hasError("maxlength")) {
                {{ rejectionReasonMaxLength }}
              } @else if (form.controls.reasonAR.hasError("leadingOrTrailingSpaces")) {
                {{ rejectionReasonArabicSpaces }}
              } @else if (form.controls.reasonAR.hasError("numbersNotAllowed")) {
                {{ rejectionReasonNumbersNotAllowed }}
              } @else if (form.controls.reasonAR.hasError("invalidArabicCharacters")) {
                {{ rejectionReasonArabicCharacters }}
              }
            </p>
          }
        </div>
        <div class="flex flex-col gap-2">
          <label class="text-[14px] font-semibold text-gray-700">
            {{ reasonEnglishLabel }}
          </label>
          <app-filter-input
            label=""
            [placeholder]="reasonENPlaceholder"
            [value]="form.controls.reasonEN.value"
            (valueChange)="onEnglishValueChange($event)"
            [isInvalid]="showValidationErrors() && form.controls.reasonEN.invalid"></app-filter-input>

          @if (showValidationErrors() && form.controls.reasonEN.errors) {
            <p class="text-sm text-red-600">
              @if (form.controls.reasonEN.hasError("minlength")) {
                {{ rejectionReasonMinLength }}
              } @else if (form.controls.reasonEN.hasError("maxlength")) {
                {{ rejectionReasonMaxLength }}
              } @else if (form.controls.reasonEN.hasError("leadingOrTrailingSpaces")) {
                {{ rejectionReasonEnglishSpaces }}
              } @else if (form.controls.reasonEN.hasError("numbersNotAllowed")) {
                {{ rejectionReasonNumbersNotAllowed }}
              } @else if (form.controls.reasonEN.hasError("invalidEnglishCharacters")) {
                {{ rejectionReasonEnglishCharacters }}
              }
            </p>
          }
        </div>
      </div>
      <div class="mt-6 flex justify-end gap-3">
        <div (click)="goBack()">
          <app-submit-button type="secondary">
            <span i18n="@@adminProductsDeleteCancel">Cancel</span>
          </app-submit-button>
        </div>
        <div (click)="onSubmit()">
          <app-submit-button type="primary">
            <span i18n="@@adminCategoriesSubmitButton">Submit</span>
          </app-submit-button>
        </div>
      </div>
    </div>
  </div>

  @if (showConfirmation()) {
    <app-confirmation-dialog
      [layout]="'start'"
      [title]="confirmCreateReasonTitle"
      [description]="confirmCreateReasonDescription"
      [confirmContent]="confirmButton()"
      [cancelContent]="cancelButton"
      [error]="createReasonError()"
      (onCancel)="closeConfirmation()"
      (onSubmit)="onConfirmCreate()"></app-confirmation-dialog>
  }
  @if (showCreateSuccess()) {
    <app-successful-notification type="success" [title]="successTitle()" />
  }
</form>
